import React, { useEffect, useState } from "react";
import {
  ActionHeader,
  ActionItemContainer,
  ActionLabelDisplay,
  ActionTitle,
  FormInput,
  FormInputContainer,
  FormInputDescription,
  FormInputError,
  FormInputLabel,
} from "../styles";
import { useDispatch, useSelector } from "react-redux";
import { getTagsByCompanyAction } from "../../../../../redux/tagsDuck";
import { getAgentsAction } from "../../../../../redux/agentsDuck";
import { Controller } from "react-hook-form";
import { MultiSelect } from "./multi-select";
import { useFileHandler } from "../hooks/use-file-handler";
import { TEMPLATE_MAX_SIZE_FILE_MB } from "../constants/template";
import { ActionTypeToggle, RESPONSE_TYPE } from "./action-type-toggle";
import { MediaDropZone } from "./media-drop-zone";

export const BroadcastActionItem = ({
  index,
  control,
  register,
  errors,
  action,
  onMediaFileChange,
}) => {
  const agents = useSelector((state) => state.agents);
  const tags = useSelector((state) => state.tags);
  const dispatch = useDispatch();

  const initialType = action.mediaFile ? RESPONSE_TYPE.IMAGE : RESPONSE_TYPE.TEXT;
  const [responseType, setResponseType] = useState(initialType);

  const { file, previewUrl, fileTypeDisplayName, formattedFileSize, handleFile, handleRemoveFile } =
    useFileHandler({ initialFile: action.mediaFile ?? null, maxSize: TEMPLATE_MAX_SIZE_FILE_MB });

  useEffect(() => {
    dispatch(getTagsByCompanyAction());
    dispatch(getAgentsAction());
  }, []);

  useEffect(() => {
    if (onMediaFileChange) {
      onMediaFileChange(index, responseType === RESPONSE_TYPE.IMAGE ? file : null);
    }
  }, [file, responseType]);

  const handleTypeChange = (type) => {
    if (type === RESPONSE_TYPE.TEXT && file) handleRemoveFile();
    setResponseType(type);
  };

  const agentOptions = (agents.data || []).map((agent) => ({ value: agent.id, label: agent.name }));
  const tagOptions = (tags.data || []).map((tag) => ({ value: tag.name, label: tag.name }));

  const isText = responseType === RESPONSE_TYPE.TEXT;
  const isImage = responseType === RESPONSE_TYPE.IMAGE;

  return (
    <ActionItemContainer>
      <ActionHeader>
        <ActionTitle>Botón {index + 1}</ActionTitle>
        <ActionLabelDisplay>{action.label}</ActionLabelDisplay>
      </ActionHeader>

      <input
        type="hidden"
        name={`actions[${index}].label`}
        defaultValue={action.label}
        ref={register()}
      />

      <div style={{ display: "grid", gap: "1.5rem" }}>
        <FormInputContainer>
          <FormInputLabel>Asignar agente (Opcional)</FormInputLabel>
          <Controller
            name={`actions[${index}].agents`}
            control={control}
            defaultValue={[]}
            as={<MultiSelect options={agentOptions} placeholder="Selecciona un agente..." />}
          />
          {errors?.actions?.[index]?.agents && (
            <FormInputError>{errors.actions[index].agents.message}</FormInputError>
          )}
        </FormInputContainer>

        <FormInputContainer>
          <FormInputLabel>Asignar etiquetas (Opcional)</FormInputLabel>
          <Controller
            name={`actions[${index}].tags`}
            control={control}
            defaultValue={[]}
            as={<MultiSelect options={tagOptions} placeholder="Selecciona una etiqueta..." />}
          />
          <FormInputDescription>Asigna etiquetas para clasificar la respuesta.</FormInputDescription>
        </FormInputContainer>

        <FormInputContainer>
          <FormInputLabel>Tipo de respuesta (Opcional)</FormInputLabel>
          <ActionTypeToggle value={responseType} onChange={handleTypeChange} />
          <FormInputDescription>
            Elige si la respuesta automática enviará un mensaje de texto o un archivo.
          </FormInputDescription>
        </FormInputContainer>

        {isText && (
          <FormInputContainer>
            <FormInputLabel>Mensaje de Respuesta</FormInputLabel>
            <FormInput
              name={`actions[${index}].message`}
              placeholder="Mensaje automático al presionar el botón"
              ref={register()}
            />
          </FormInputContainer>
        )}

        {isImage && (
          <>
            <input type="hidden" name={`actions[${index}].message`} value="" ref={register()} />
            <FormInputContainer>
              <FormInputLabel>Imagen / Archivo adjunto</FormInputLabel>
              <MediaDropZone
                file={file}
                previewUrl={previewUrl}
                fileTypeDisplayName={fileTypeDisplayName}
                formattedFileSize={formattedFileSize}
                onFile={handleFile}
                onRemove={handleRemoveFile}
              />
              <FormInputDescription>
                Se enviará este archivo como respuesta al presionar el botón.
              </FormInputDescription>
            </FormInputContainer>
          </>
        )}
      </div>
    </ActionItemContainer>
  );
};
